module.exports = __webpack_public_path__ + "static/ui-2-3cfaf6d2d84f0fefa84a78c6f91b7da9.png";